'use client';

import { useEffect } from 'react';

import TrackViewedTreatments from '../../../lib/TrackViewedTreatments';

interface Props {
    systemId: number;
}

const TagTreatmentAsViewed = ({ systemId }: Props) => {
    useEffect(() => TrackViewedTreatments.addId(systemId), [systemId]);
    return null;
};

export default TagTreatmentAsViewed;
